import { QRCodeSVG } from 'qrcode.react'

/**
 * A scannable form of the same otpauth URI shown as a link and manual key.
 *
 * Kept as a shared component because two enrollment doors exist: the account
 * settings card and the mandatory workspace gate. A QR code on only one would
 * make the harder, unexpected path the one that still asks somebody to type.
 */
export function TotpQr({ uri }: { uri: string }) {
  return (
    <div className="totp__qr" data-totp-qr>
      <QRCodeSVG
        value={uri}
        size={176}
        level="M"
        marginSize={4}
        title="Scan to add Staleless to your authenticator"
      />
    </div>
  )
}
